// src/components/ClientsOnlineDashboard/components/ClientsPagination.tsx

import React from "react";
import "../styles/ClientsPagination.css";

interface ClientsPaginationProps {
  pagination: {
    page: number;
    totalPages: number;
    hasNextPage: boolean;
    hasPrevPage: boolean;
  };
  onPageChange: (newPage: number) => void;
}

const ClientsPagination: React.FC<ClientsPaginationProps> = ({
  pagination,
  onPageChange
}) => {
  if (pagination.totalPages <= 1) return null;

  return (
    <div className="pagination-container">
      <button
        onClick={() => onPageChange(pagination.page - 1)}
        disabled={!pagination.hasPrevPage}
        className="pagination-button"
      >
        Précédent
      </button>
      <span className="pagination-info">
        Page {pagination.page} sur {pagination.totalPages}
      </span>
      <button
        onClick={() => onPageChange(pagination.page + 1)}
        disabled={!pagination.hasNextPage}
        className="pagination-button"
      >
        Suivant
      </button>
    </div>
  );
};

export default ClientsPagination;